module.exports = __webpack_public_path__ + "static/media/fertility.2d105b7d.svg";